/**
 * amaflow: MP Size Chart (Mageplaza/Avada) – Empfehlung persistieren
 *
 * Context: Die App rendert das Recommender-Ergebnis nur im Popup
 * (.SRContent__Column--size). Nach Reload ist es weg. Dieses Script:
 * 1) speichert Größe in localStorage + Cookie (Produkt + Modell mit gleicher Tabelle)
 * 2) zeigt "Deine Größe" unter dem Size-Picker und wählt die Variante
 * 3) setzt den Inline-Größentabellen-Link neben "Größe: M | …"
 * 4) zeigt im Side Cart "Richtige Größe Berechnen" nur wenn der Size Finder
 *    auf der PDP wirklich da war (nicht bei reiner Größentabelle / ohne MP)
 */
(function () {
  /* amaflow: Notschalter – ?mm-off=1 schaltet die eigenen Skripte ab.
     Ohne den Parameter aendert sich nichts. */
  if (/[?&]mm-off=(1|alle)/.test(window.location.search)) return;

  var STORAGE_KEY = 'mm_mp_recommended_size';
  var COOKIE_KEY = 'mm_mp_size';
  var COOKIE_DAYS = 365;
  var RESULT_SELECTOR = '.SRContent__Column--size';
  var BADGE_ATTR = 'data-mm-mp-size-rec';
  var SIZE_OPTION_ATTR = 'data-mm-size-option';
  var STORAGE_VERSION = 3;

  var config = window.mmMpSizeRec || {};
  var productId = String(config.productId || '');
  var productHandle = config.productHandle || '';
  var labelText = config.label || 'Deine Größe';
  var knownSizes = Array.isArray(config.sizes) ? config.sizes : [];
  var sizeOptionNames = Array.isArray(config.sizeOptionNames) ? config.sizeOptionNames : [];
  var chartGroup = inferChartGroup(config);

  function slug(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function containsAny(haystack, needles) {
    for (var i = 0; i < needles.length; i++) {
      if (haystack.indexOf(needles[i]) !== -1) return true;
    }
    return false;
  }

  function inferChartGroup(cfg) {
    /* amaflow: nur Modelle mit derselben Größentabelle teilen (Farbe/Print), nicht alle Geschirre/Halsbänder */
    var haystack = [cfg.title, cfg.handle, cfg.productType, Array.isArray(cfg.tags) ? cfg.tags.join(' ') : '']
      .join(' ')
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss');
    var compact = haystack.replace(/[^a-z0-9]+/g, '');

    if (containsAny(haystack, ['air vest', 'air-vest', 'airvest', 'airmesh']) || compact.indexOf('airvest') !== -1) {
      return 'air-vest';
    }
    if (containsAny(haystack, ['q-fit', 'q fit', 'qfit']) || compact.indexOf('qfit') !== -1) {
      return 'q-fit';
    }
    if (
      containsAny(haystack, ['comfort h', 'comfort-h', 'komfort h', 'komfort-h', 'komforth']) ||
      compact.indexOf('comforth') !== -1 ||
      compact.indexOf('komforth') !== -1
    ) {
      return 'comfort-h';
    }
    if (
      containsAny(haystack, ['original h', 'h-geschirr', 'h geschirr', 'h-harness', 'h harness']) ||
      compact.indexOf('hharness') !== -1 ||
      compact.indexOf('hgeschirr') !== -1
    ) {
      return 'h-geschirr';
    }
    if (
      containsAny(haystack, [
        'wide collar',
        'wide-collar',
        'widecollar',
        'breites halsband',
        'breites-halsband',
        'breit halsband'
      ]) ||
      compact.indexOf('widecollar') !== -1 ||
      compact.indexOf('breiteshalsband') !== -1
    ) {
      return 'breites-halsband';
    }
    if (
      containsAny(haystack, ['katzenhalsband', 'katzen-halsband', 'cat collar', 'cat-collar', 'katzenhalsung']) ||
      compact.indexOf('catcollar') !== -1 ||
      compact.indexOf('katzenhalsband') !== -1
    ) {
      return 'katzenhalsband';
    }
    if (containsAny(haystack, ['halsband', 'collar', 'halsung'])) {
      return 'halsband';
    }
    if (containsAny(haystack, ['bandana'])) {
      return 'bandana';
    }
    if (
      containsAny(haystack, [
        'mantel',
        'jacket',
        'coat',
        'pullover',
        'hoodie',
        'regenmantel',
        'raincoat',
        'wintermantel'
      ])
    ) {
      return 'mantel';
    }
    if (
      containsAny(haystack, ['multifunktionsleine', 'multifunction', 'multi-function', 'multi function']) ||
      compact.indexOf('multifunktionsleine') !== -1 ||
      compact.indexOf('multifunctionleash') !== -1
    ) {
      return 'multifunktionsleine';
    }
    if (containsAny(haystack, ['kurzleine', 'short leash', 'short-leash', 'traffic leash'])) {
      return 'kurzleine';
    }
    if (
      containsAny(haystack, ['seilleine', 'tauleine', 'rope leash', 'rope-leash', 'ropeleash']) ||
      compact.indexOf('ropeleash') !== -1
    ) {
      return 'seilleine';
    }
    if (containsAny(haystack, ['leine', 'leash'])) {
      return 'leine';
    }

    return '';
  }

  function normalizeSize(raw) {
    var text = String(raw || '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!text || text.length > 16) return '';
    if (!/^[A-Za-z0-9][A-Za-z0-9+\/.\- ]{0,14}$/.test(text)) return '';
    return text;
  }

  function sizesMatch(a, b) {
    return String(a || '').replace(/\s+/g, '').toUpperCase() === String(b || '').replace(/\s+/g, '').toUpperCase();
  }

  var knownSizeMap = {};
  knownSizes.forEach(function (size) {
    knownSizeMap[String(size).replace(/\s+/g, '').toUpperCase()] = true;
  });

  function sizeExistsOnProduct(size) {
    if (!knownSizes.length) return false;
    return Boolean(knownSizeMap[String(size).replace(/\s+/g, '').toUpperCase()]);
  }

  var defaultSizeNames = ['größe', 'groesse', 'grosse', 'size', 'talla', 'taille', 'taglia'];
  var sizeNameSet = {};
  defaultSizeNames.concat(sizeOptionNames).forEach(function (name) {
    var key = String(name || '').toLowerCase().replace(/:$/, '').trim();
    if (key) sizeNameSet[key] = true;
  });

  function isSizeOptionName(name) {
    var key = String(name || '')
      .toLowerCase()
      .replace(/:$/, '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!key) return false;
    if (sizeNameSet[key]) return true;
    return /^(größe|groesse|grosse|size|talla|taille|taglia)\b/.test(key);
  }

  function emptyStore() {
    return { v: STORAGE_VERSION, products: {}, charts: {}, groups: {}, finders: {} };
  }

  function migrateStore(parsed) {
    var store = emptyStore();
    if (!parsed || typeof parsed !== 'object') return store;

    if (parsed.products && typeof parsed.products === 'object') {
      Object.keys(parsed.products).forEach(function (id) {
        var entry = parsed.products[id];
        if (entry && entry.size) store.products[id] = entry;
      });
    }
    if (parsed.charts && typeof parsed.charts === 'object') store.charts = parsed.charts;
    if (Number(parsed.v) >= STORAGE_VERSION && parsed.groups && typeof parsed.groups === 'object') {
      store.groups = parsed.groups;
    }
    if (parsed.finders && typeof parsed.finders === 'object') {
      Object.keys(parsed.finders).forEach(function (id) {
        if (parsed.finders[id] === true) store.finders[id] = true;
      });
    }
    return store;
  }

  var storeCache = null;

  function readStore() {
    /* amaflow: localStorage zuerst, Cookie als Fallback (kompakt: charts + groups) */
    if (storeCache) return storeCache;

    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (raw) {
        storeCache = migrateStore(JSON.parse(raw));
        return storeCache;
      }
    } catch (e) {}

    try {
      var cookieRaw = readCookie(COOKIE_KEY);
      if (cookieRaw && cookieRaw.charAt(0) === '{') {
        storeCache = migrateStore(JSON.parse(cookieRaw));
        return storeCache;
      }
    } catch (e) {}

    storeCache = emptyStore();
    return storeCache;
  }

  function writeStore(store) {
    store.v = STORAGE_VERSION;
    storeCache = store;
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
    } catch (e) {}

    try {
      var compact = {
        v: STORAGE_VERSION,
        charts: store.charts || {},
        groups: store.groups || {}
      };
      writeCookie(COOKIE_KEY, JSON.stringify(compact), COOKIE_DAYS);
    } catch (e) {}
  }

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function writeCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/' + secure + '; SameSite=Lax';
  }

  function usableSize(size) {
    var normalized = normalizeSize(size);
    if (!normalized || !sizeExistsOnProduct(normalized)) return '';
    return normalized;
  }

  function getSizeForCurrentProduct(store) {
    if (productId && store.products && store.products[productId]) {
      var productSize = usableSize(store.products[productId].size);
      if (productSize) return productSize;
    }

    /* amaflow: Gruppen-Fallback nur für dasselbe Modell (andere Farbe), nicht für Produkttyp Geschirr/Halsband */
    if (chartGroup && store.groups && store.groups[chartGroup]) {
      var groupSize = usableSize(store.groups[chartGroup].size);
      if (groupSize) return groupSize;
    }

    return '';
  }

  function captureChartKey() {
    var result = document.querySelector(RESULT_SELECTOR);
    if (!result) return '';
    var roots = [result.closest('[class*="SRContent"]') || result.parentElement || result];

    var labels = [];
    var keyword = /(brust|hals|gewicht|taille|huefte|hüfte|rücken|ruecken|schulter|arm|bein|bund|länge|laenge|weite|umfang|inseam|chest|waist|hip|neck|weight|height|back|shoulder|sleeve|thigh)/i;

    roots.forEach(function (root) {
      var chartId = root.getAttribute('data-chart-id') || root.getAttribute('data-id') || '';
      if (chartId) labels.push('id:' + slug(chartId));

      root.querySelectorAll('label, th, [class*="label"], [class*="Label"], [class*="field-title"]').forEach(function (el) {
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (!text || text.length > 48) return;
        if (keyword.test(text)) labels.push(slug(text));
      });

      root.querySelectorAll('input, select, textarea').forEach(function (el) {
        var hint = [el.getAttribute('name'), el.getAttribute('placeholder'), el.getAttribute('aria-label')].join(' ');
        if (keyword.test(hint)) labels.push(slug(hint));
      });
    });

    labels = labels.filter(Boolean).filter(function (item, index, all) {
      return all.indexOf(item) === index;
    }).sort();

    return labels.length ? labels.join('|') : '';
  }

  var lastRendered = '';
  var userOverrodeSize = false;
  var selectingProgrammatically = false;

  function getSizeOptionRoots() {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[' + SIZE_OPTION_ATTR + ']'));
    if (roots.length) return roots;

    document.querySelectorAll('variant-selects .product-form__input').forEach(function (root) {
      var legend = root.querySelector('.form__label .font-body-bolder, legend, label.block');
      var text = legend ? legend.textContent : '';
      if (isSizeOptionName(text)) roots.push(root);
    });

    if (roots.length) return roots;

    document.querySelectorAll('variant-selects select[name^="options["]').forEach(function (sel) {
      var name = sel.getAttribute('name') || '';
      var match = name.match(/^options\[(.+)\]$/);
      if (match && isSizeOptionName(match[1])) {
        roots.push(sel.closest('.product-form__input') || sel);
      }
    });

    return roots;
  }

  function getSizeRadios() {
    var radios = [];
    getSizeOptionRoots().forEach(function (root) {
      root.querySelectorAll('input[type="radio"]').forEach(function (input) {
        radios.push(input);
      });
    });
    return radios;
  }

  function getSizeSelects() {
    var selects = [];
    getSizeOptionRoots().forEach(function (root) {
      root.querySelectorAll('select[name^="options["]').forEach(function (sel) {
        selects.push(sel);
      });
    });
    return selects;
  }

  function isRecommendedSizeInput(el) {
    if (!el || !el.matches) return false;
    if (el.closest('[' + SIZE_OPTION_ATTR + ']')) return true;
    if (el.matches('variant-selects input[type="radio"]') && isSizeOptionName(guessOptionName(el))) return true;
    if (el.matches('variant-selects select[name^="options["]')) {
      var name = el.getAttribute('name') || '';
      var match = name.match(/^options\[(.+)\]$/);
      return Boolean(match && isSizeOptionName(match[1]));
    }
    return false;
  }

  function guessOptionName(el) {
    var root = el.closest('.product-form__input');
    if (!root) return '';
    var legend = root.querySelector('.form__label .font-body-bolder, legend');
    return legend ? legend.textContent : '';
  }

  function markUserOverride() {
    userOverrodeSize = true;
    clearRecommendedMarks();
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('variant-selects')) {
      parkAvadaButton();
    }
    if (selectingProgrammatically) return;
    if (!isRecommendedSizeInput(event.target)) return;
    markUserOverride();
  }, true);

  document.addEventListener('click', function (event) {
    if (selectingProgrammatically) return;
    var target = event.target;
    if (!target || !target.closest) return;
    var root = target.closest('[' + SIZE_OPTION_ATTR + '], variant-selects .product-form__input');
    if (!root) return;
    if (!root.hasAttribute(SIZE_OPTION_ATTR) && !isSizeOptionName(guessOptionName(root))) return;
    if (!target.closest('label, input[type="radio"], select')) return;
    markUserOverride();
  }, true);

  function isAlreadySelected(size) {
    var radios = getSizeRadios();
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked && sizesMatch(radios[i].value, size)) return true;
    }

    var selects = getSizeSelects();
    for (var j = 0; j < selects.length; j++) {
      var sel = selects[j];
      var selected = sel.options[sel.selectedIndex];
      if (sizesMatch(sel.value, size) || (selected && sizesMatch(selected.text, size))) return true;
    }
    return false;
  }

  function syncSizeSelect(size) {
    getSizeSelects().forEach(function (sel) {
      var changed = false;
      Array.prototype.forEach.call(sel.options, function (opt) {
        var should = sizesMatch(opt.value, size) || sizesMatch(opt.text, size);
        if (should && !opt.selected) changed = true;
        if (should) {
          opt.selected = true;
          sel.value = opt.value;
        }
      });
      if (changed) {
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function selectRecommendedSize(size, force) {
    /* amaflow: Variante in variant-selects setzen, außer der Kunde hat selbst umgeschaltet */
    var normalized = usableSize(size);
    if (!normalized) return;
    if (!force && userOverrodeSize) return;
    if (isAlreadySelected(normalized)) return;

    selectingProgrammatically = true;
    try {
      var radios = getSizeRadios();
      var match = null;
      var fallback = null;
      radios.forEach(function (input) {
        if (!sizesMatch(input.value, normalized)) return;
        if (!fallback) fallback = input;
        if (!input.classList.contains('disabled') && !input.disabled && !match) match = input;
      });
      var target = match || fallback;

      if (target) {
        target.checked = true;
        target.dispatchEvent(new Event('input', { bubbles: true }));
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }

      syncSizeSelect(normalized);
    } finally {
      window.setTimeout(function () {
        selectingProgrammatically = false;
      }, 0);
    }
  }

  function saveSize(size, chartKey, shouldSelect) {
    var normalized = usableSize(size);
    if (!normalized) return '';

    var store = readStore();
    var key = chartKey || captureChartKey();
    var entry = {
      size: normalized,
      handle: productHandle,
      group: chartGroup,
      chartKey: key,
      at: Date.now()
    };

    store.products = store.products || {};
    store.charts = store.charts || {};
    store.groups = store.groups || {};

    if (productId) store.products[productId] = entry;
    if (key) store.charts[key] = { size: normalized, group: chartGroup, at: entry.at };
    if (chartGroup) store.groups[chartGroup] = { size: normalized, chartKey: key, at: entry.at };

    writeStore(store);
    persistFinderForCurrentProduct();
    render(normalized);
    if (shouldSelect) selectRecommendedSize(normalized, true);
    updateCartSizeCtas();
    return normalized;
  }

  var lastCapturedSize = '';

  function captureFromApp() {
    /* amaflow: liest .SRContent__Column--size aus dem MP-Popup und speichert bei neuem Ergebnis */
    var nodes = document.querySelectorAll(RESULT_SELECTOR);
    if (!nodes.length) {
      lastCapturedSize = '';
      return '';
    }

    var captured = '';
    var chartKey = captureChartKey();

    nodes.forEach(function (node) {
      var size = normalizeSize(node.textContent);
      if (!size) return;
      if (!captured || sizeExistsOnProduct(size)) captured = size;
    });

    if (captured && sizeExistsOnProduct(captured)) {
      var isNewResult = lastCapturedSize !== captured;
      lastCapturedSize = captured;
      saveSize(captured, chartKey, isNewResult);
    }
    return captured;
  }

  function isInAppPopup(el) {
    if (!el) return false;
    return Boolean(
      el.closest('[class*="SRContent"], [class*="size-chart-modal"], [class*="SizeChart"], [role="dialog"]')
    );
  }

  function isFloatingWidget(el) {
    if (!el) return false;
    var classId = ((el.className && el.className.toString()) || '') + ' ' + (el.id || '');
    if (/float/i.test(classId)) return true;

    var style = window.getComputedStyle(el);
    if (style.position === 'fixed') return true;

    var parent = el.parentElement;
    if (!parent || parent === document.body) return false;
    var parentStyle = window.getComputedStyle(parent);
    if (parentStyle.position !== 'fixed') return false;
    var rect = parent.getBoundingClientRect();
    return rect.width < 280 && rect.height < 160;
  }

  function isSizeChartTrigger(el) {
    if (!el || el.hasAttribute(BADGE_ATTR) || el.closest('[' + BADGE_ATTR + ']')) return false;
    if (isInAppPopup(el) || isFloatingWidget(el)) return false;

    var text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (
      text.indexOf('größentabelle') !== -1 ||
      text.indexOf('groessentabelle') !== -1 ||
      text.indexOf('size chart') !== -1 ||
      text.indexOf('size guide') !== -1 ||
      text.indexOf('größenberatung') !== -1
    ) {
      return true;
    }

    var classId = ((el.className && el.className.toString()) || '') + ' ' + (el.id || '');
    classId = classId.toLowerCase();
    return (
      classId.indexOf('open-size-chart') !== -1 ||
      classId.indexOf('size-chart') !== -1 ||
      classId.indexOf('sizechart') !== -1 ||
      classId.indexOf('mp-size') !== -1 ||
      classId.indexOf('avada-size') !== -1
    );
  }

  var cachedButton = null;

  function findSizeChartButton() {
    if (cachedButton && cachedButton.isConnected) return cachedButton;

    var selectors = [
      '#Avada-SC-button',
      '.open-size-chart',
      '[class*="mp-size-chart"]',
      '[id*="mp-size-chart"]',
      '[class*="avada-size"]',
      '[id*="avada-size"]',
      '[class*="size-chart"]',
      '[id*="size-chart"]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var nodes = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < nodes.length; j++) {
        if (isSizeChartTrigger(nodes[j])) {
          cachedButton = nodes[j];
          return cachedButton;
        }
      }
    }

    var scope = document.querySelector('product-info') || document.querySelector('variant-selects');
    if (scope) {
      var candidates = scope.querySelectorAll('a, button');
      for (var k = 0; k < candidates.length; k++) {
        if (isSizeChartTrigger(candidates[k])) {
          cachedButton = candidates[k];
          return cachedButton;
        }
      }
    }

    return null;
  }

  var avadaParkHost = null;

  /* amaflow: Avada-Button erst verschieben wenn Inhalt da ist, sonst bleibt #Avada-SC-button leer */

  function isAvadaReady(node) {
    return Boolean(node && node.querySelector && node.querySelector('.Avada-inline-button, .inline-button-text, svg'));
  }

  function getAvadaWidget() {
    var customs = document.querySelectorAll('mageplaza_sc');
    var i;
    for (i = 0; i < customs.length; i++) {
      if (isAvadaReady(customs[i]) && !customs[i].closest('[role="dialog"]')) return customs[i];
    }

    var button = document.getElementById('Avada-SC-button');
    if (isAvadaReady(button) && !button.closest('[role="dialog"]')) {
      return button.closest('mageplaza_sc') || button;
    }

    return null;
  }

  function getAvadaParkHost() {
    if (avadaParkHost && avadaParkHost.isConnected) return avadaParkHost;
    avadaParkHost = document.querySelector('[data-mm-avada-park]');
    if (!avadaParkHost) {
      avadaParkHost = document.createElement('div');
      avadaParkHost.setAttribute('data-mm-avada-park', '');
      avadaParkHost.hidden = true;
      document.body.appendChild(avadaParkHost);
    }
    return avadaParkHost;
  }

  function getSizeChartSlot() {
    var root = getSizeOptionRoots()[0];
    if (!root) return null;
    return root.querySelector('[data-mm-size-chart-slot]') || root.querySelector('.form__label');
  }

  function returnEmptyButtonToHost() {
    var slot = getSizeChartSlot();
    if (!slot) return;
    var emptyButton = slot.querySelector('#Avada-SC-button');
    if (!emptyButton || isAvadaReady(emptyButton)) return;

    var host = emptyButton.closest('mageplaza_sc');
    if (host) return;

    var custom = document.querySelector('mageplaza_sc');
    if (custom && !custom.contains(emptyButton)) {
      custom.appendChild(emptyButton);
    }
  }

  function parkAvadaButton() {
    /* amaflow: vor Variant-HTML-Swap rausnehmen, sonst zerstört FoxTheme das Widget */
    var widget = getAvadaWidget();
    if (!widget || widget.closest('[role="dialog"]')) return;
    var host = getAvadaParkHost();
    if (widget.parentElement !== host) host.appendChild(widget);
  }

  function placeAvadaButton() {
    /* amaflow: mageplaza_sc in den Slot neben "Größe: M" hängen */
    returnEmptyButtonToHost();

    var widget = getAvadaWidget();
    var slot = getSizeChartSlot();
    if (!widget || !slot || widget.closest('[role="dialog"]')) return;
    if (widget.parentElement !== slot) slot.appendChild(widget);
    cachedButton = widget.querySelector('#Avada-SC-button') || widget;
    styleAvadaText();
    watchAvadaText();
  }

  function getCartItemRecommendedSize(item) {
    /* amaflow: gleiche Storage-Logik wie "Deine Größe" auf der PDP */
    var store = readStore();
    var id = String(item.getAttribute('data-product-id') || '');
    if (id && store.products && store.products[id] && store.products[id].size) {
      return store.products[id].size;
    }

    var group = inferChartGroup({
      title: item.getAttribute('data-product-title') || '',
      handle: item.getAttribute('data-handle') || '',
      productType: item.getAttribute('data-product-type') || '',
      tags: []
    });
    /* amaflow: Cart-Fallback nur gleiches Modell, nicht Produkttyp Geschirr */
    if (group && store.groups && store.groups[group] && store.groups[group].size) {
      return store.groups[group].size;
    }
    return '';
  }

  function cartItemHasRecommendation(item) {
    return Boolean(getCartItemRecommendedSize(item));
  }

  function hasSizeFinderWidget() {
    /* amaflow: derselbe Nachweis wie die PDP-Leiste – nur der Recommender,
       nicht der reine Größentabellen-Link (oft ohne role="button") */
    return Boolean(
      document.documentElement.classList.contains('mm-has-size-finder') ||
        document.querySelector('mageplaza_sc [role="button"], #Avada-SC-button [role="button"]')
    );
  }

  function persistFinderForCurrentProduct() {
    if (!productId) return;
    var store = readStore();
    store.finders = store.finders || {};
    if (store.finders[productId] === true) return;
    store.finders[productId] = true;
    writeStore(store);
    updateCartSizeCtas();
  }

  function persistSizeFinderIfPresent() {
    if (!hasSizeFinderWidget()) return;
    persistFinderForCurrentProduct();
  }

  function cartItemHasSizeFinder(item) {
    var id = String(item.getAttribute('data-product-id') || '');
    if (!id) return false;
    var store = readStore();
    if (store.finders && store.finders[id] === true) return true;
    if (productId && id === productId && hasSizeFinderWidget()) return true;
    return false;
  }

  window.mmMpSizeRecMarkFinder = function () {
    persistSizeFinderIfPresent();
  };

  function updateCartSizeCtas() {
    /* amaflow: Side Cart + Hauptwarenkorb – Empfehlung oder Berechnen-Link unter der Größe */
    document.querySelectorAll('.cart-item').forEach(function (item) {
      var rec = item.querySelector('[data-mm-cart-size-rec]');
      var valueEl = item.querySelector('[data-mm-cart-size-rec-value]');
      var cta = item.querySelector('[data-mm-cart-size-cta]');
      if (!item.hasAttribute('data-mm-has-size')) {
        if (rec) rec.hidden = true;
        if (cta) cta.hidden = true;
        return;
      }

      var size = getCartItemRecommendedSize(item);
      if (size) {
        if (valueEl) valueEl.textContent = size;
        if (rec) rec.hidden = false;
        if (cta) cta.hidden = true;
      } else if (cartItemHasSizeFinder(item)) {
        if (valueEl) valueEl.textContent = '';
        if (rec) rec.hidden = true;
        if (cta) cta.hidden = false;
      } else {
        if (valueEl) valueEl.textContent = '';
        if (rec) rec.hidden = true;
        if (cta) cta.hidden = true;
      }
    });
  }

  function onCartSizeCtaClick(event) {
    var cta = event.target.closest('[data-mm-cart-size-cta]');
    if (!cta) return;

    try {
      sessionStorage.setItem('mm_mp_open_size_chart', '1');
    } catch (e) {}

    var item = cta.closest('.cart-item');
    var handle = item && item.getAttribute('data-handle');
    var currentHandle = (window.mmMpSizeRec || {}).productHandle;
    if (!handle || !currentHandle || handle !== currentHandle) return;

    event.preventDefault();
    closeCartDrawer();
    openAvadaPopup(0);
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.hide === 'function') drawer.hide();
  }

  function shouldOpenSizeChart() {
    try {
      if (sessionStorage.getItem('mm_mp_open_size_chart') === '1') return true;
    } catch (e) {}
    try {
      return new URLSearchParams(window.location.search).get('open_size_chart') === '1';
    } catch (e) {}
    return false;
  }

  function clearOpenSizeChartFlag() {
    try {
      sessionStorage.removeItem('mm_mp_open_size_chart');
    } catch (e) {}
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('open_size_chart')) return;
      url.searchParams.delete('open_size_chart');
      var next = url.pathname + url.search + url.hash;
      window.history.replaceState({}, '', next);
    } catch (e) {}
  }

  function clickAvadaTrigger() {
    var trigger = document.querySelector(
      '#Avada-SC-button .Avada-inline-button, #Avada-SC-button [role="button"]'
    );
    if (!trigger) return false;
    if (typeof trigger.click === 'function') trigger.click();
    else trigger.dispatchEvent(new MouseEvent('click', { bubbles: true }));
    return true;
  }

  function openAvadaPopup(attempt) {
    attempt = attempt || 0;
    placeAvadaButton();
    if (clickAvadaTrigger()) {
      clearOpenSizeChartFlag();
      return;
    }
    if (attempt < 20) {
      window.setTimeout(function () {
        openAvadaPopup(attempt + 1);
      }, 250);
    } else {
      clearOpenSizeChartFlag();
    }
  }

  function maybeOpenSizeChartFromCart() {
    /* amaflow: vom Side-Cart-Link ?open_size_chart=1 → PDP laden und App-Popup klicken */
    if (!shouldOpenSizeChart()) return;
    closeCartDrawer();
    openAvadaPopup(0);
  }

  function bindCartSizeCtas() {
    document.addEventListener('click', onCartSizeCtaClick);

    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function () {
        window.setTimeout(updateCartSizeCtas, 0);
      });
    }
    document.addEventListener('cart:refresh', function () {
      window.setTimeout(updateCartSizeCtas, 50);
    });

    var drawer = document.querySelector('cart-drawer');
    var mainCart = document.querySelector('main-cart');
    [drawer, mainCart].forEach(function (root) {
      if (!root) return;
      var timer = null;
      new MutationObserver(function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(updateCartSizeCtas, 50);
      }).observe(root, { childList: true, subtree: true });
    });
  }

  var stylingAvadaText = false;
  var avadaTextObserver = null;

  function styleAvadaText() {
    /* amaflow: App setzt font-weight 400 inline; Schrift soll wie "Größe:" bleiben, Icon unangetastet */
    var root = document.getElementById('Avada-SC-button');
    if (!root) return;

    stylingAvadaText = true;
    root.querySelectorAll('.inline-button-text').forEach(function (el) {
      el.classList.add('font-body-bolder');
      el.style.setProperty('font-family', 'var(--font-body-family)', 'important');
      el.style.setProperty('font-weight', 'var(--font-body-weight-bolder)', 'important');
      el.style.setProperty('font-style', 'var(--font-body-style)', 'important');
      el.style.setProperty('font-size', 'inherit', 'important');
      el.style.setProperty('line-height', 'inherit', 'important');
      el.style.setProperty('color', 'rgb(var(--color-foreground))', 'important');
      el.style.setProperty('text-decoration', 'none', 'important');
    });
    window.setTimeout(function () {
      stylingAvadaText = false;
    }, 0);
  }

  function watchAvadaText() {
    var root = document.getElementById('Avada-SC-button');
    if (!root) return;
    if (avadaTextObserver) avadaTextObserver.disconnect();

    avadaTextObserver = new MutationObserver(function () {
      if (stylingAvadaText) return;
      styleAvadaText();
    });
    avadaTextObserver.observe(root, {
      attributes: true,
      attributeFilter: ['style', 'class'],
      childList: true,
      subtree: true
    });
  }

  function ensureBadge() {
    var existing = document.querySelector('[' + BADGE_ATTR + ']');
    if (existing) return existing;

    var badge = document.createElement('div');
    badge.className = 'mm-mp-size-rec flex flex-wrap gap-2';
    badge.setAttribute(BADGE_ATTR, '');
    badge.hidden = true;
    badge.innerHTML =
      '<span class="font-body-bolder mm-mp-size-rec__text"></span>' +
      '<span class="text-subtext mm-mp-size-rec__size" data-mm-mp-size-value></span>';
    return badge;
  }

  function placeBadge(badge) {
    if (badge.isConnected && document.querySelector('[' + BADGE_ATTR + ']') === badge) {
      return;
    }

    var trigger = findSizeChartButton();
    if (trigger) {
      var triggerRow = trigger.closest('.form__label, .flex.items-center, [class*="size-chart"]') || trigger;
      triggerRow.insertAdjacentElement('afterend', badge);
      return;
    }

    var sizeRoot = getSizeOptionRoots()[0];
    if (sizeRoot) {
      var label = sizeRoot.querySelector('.form__label');
      if (label) {
        label.insertAdjacentElement('afterend', badge);
        return;
      }
      sizeRoot.insertAdjacentElement('afterbegin', badge);
      return;
    }

    var productInfo = document.querySelector('product-info variant-selects, product-info, .product__info');
    if (productInfo) productInfo.appendChild(badge);
  }

  function clearRecommendedMarks() {
    document.querySelectorAll('.mm-mp-recommended, .mm-mp-recommended-input').forEach(function (el) {
      el.classList.remove('mm-mp-recommended', 'mm-mp-recommended-input');
    });
  }

  function markRecommended(size) {
    clearRecommendedMarks();
    if (userOverrodeSize) return;
    if (!isAlreadySelected(size)) return;
  }

  function labelWithColon(text) {
    var label = String(text || '').replace(/\s*:$/, '').trim();
    return label ? label + ':' : '';
  }

  function hide() {
    lastRendered = '';
    var badge = document.querySelector('[' + BADGE_ATTR + ']');
    if (badge) {
      badge.hidden = true;
      badge.classList.remove('is-visible');
      var valueEl = badge.querySelector('[data-mm-mp-size-value]');
      if (valueEl) valueEl.textContent = '';
    }
    clearRecommendedMarks();
  }

  function render(size) {
    var normalized = usableSize(size);
    if (!normalized) {
      hide();
      return;
    }

    var badge = ensureBadge();
    var valueEl = badge.querySelector('[data-mm-mp-size-value]');
    if (lastRendered === normalized && !badge.hidden && valueEl && valueEl.textContent === normalized && badge.isConnected) {
      markRecommended(normalized);
      return;
    }

    var textEl = badge.querySelector('.mm-mp-size-rec__text');
    if (textEl) textEl.textContent = labelWithColon(labelText);
    if (valueEl) valueEl.textContent = normalized;
    badge.hidden = false;
    badge.classList.add('is-visible');
    lastRendered = normalized;
    placeBadge(badge);
    markRecommended(normalized);
  }

  function restore() {
    placeAvadaButton();
    persistSizeFinderIfPresent();
    captureFromApp();
    var size = getSizeForCurrentProduct(readStore());
    if (size) {
      render(size);
      selectRecommendedSize(size, false);
    } else {
      hide();
    }
  }

  function refreshAfterDomSwap() {
    cachedButton = cachedButton && cachedButton.isConnected ? cachedButton : null;
    placeAvadaButton();
    var size = lastRendered || getSizeForCurrentProduct(readStore());
    if (size) {
      render(size);
      if (!userOverrodeSize) selectRecommendedSize(size, false);
    }
  }

  function nodeLooksRelevant(node) {
    if (!node || node.nodeType !== 1) return false;
    var hint = ((node.className && node.className.toString()) || '') + ' ' + (node.id || '');
    hint = hint.toLowerCase();
    var tag = (node.tagName || '').toLowerCase();
    return (
      tag === 'mageplaza_sc' ||
      node.id === 'Avada-SC-button' ||
      hint.indexOf('srcontent') !== -1 ||
      hint.indexOf('size-chart') !== -1 ||
      hint.indexOf('sizechart') !== -1 ||
      hint.indexOf('mp-size') !== -1 ||
      hint.indexOf('avada-size') !== -1 ||
      hint.indexOf('avada-sc') !== -1 ||
      hint.indexOf('avada-inline') !== -1 ||
      hint.indexOf('mploaded') !== -1 ||
      hint.indexOf('variant-selects') !== -1
    );
  }

  function mutationLooksRelevant(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      var target = mutation.target;
      if (target && target.closest && target.closest('[' + BADGE_ATTR + ']')) continue;
      if (nodeLooksRelevant(target)) return true;

      var added = mutation.addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (nodeLooksRelevant(node)) return true;
        if (node.nodeType === 1 && node.querySelector && node.querySelector(RESULT_SELECTOR + ', [' + BADGE_ATTR + '], [' + SIZE_OPTION_ATTR + '], #Avada-SC-button, mageplaza_sc, .Avada-inline-button')) {
          return true;
        }
      }
    }
    return false;
  }

  function bindObserver() {
    /* amaflow: nur Size-Chart-/Finder-DOM, 150ms gebündelt – nicht bei jedem Widget-Tick */
    var timer = null;
    var observer = new MutationObserver(function (mutations) {
      if (!mutationLooksRelevant(mutations)) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        timer = null;
        cachedButton = cachedButton && cachedButton.isConnected ? cachedButton : null;
        placeAvadaButton();
        persistSizeFinderIfPresent();
        captureFromApp();
        if (lastRendered) {
          var badge = document.querySelector('[' + BADGE_ATTR + ']');
          if (badge) render(lastRendered);
        }
      }, 150);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function bindThemeEvents() {
    document.addEventListener('shopify:section:load', restore);
    document.addEventListener('variant:changed', refreshAfterDomSwap);

    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, refreshAfterDomSwap);
    }
  }

  function init() {
    /* amaflow: Cart-CTA auf allen Seiten; PDP-Logik nur wenn das Produkt Größen hat */
    bindCartSizeCtas();
    persistSizeFinderIfPresent();
    updateCartSizeCtas();

    if (!knownSizes.length) return;
    restore();
    bindObserver();
    bindThemeEvents();
    window.setTimeout(placeAvadaButton, 300);
    window.setTimeout(restore, 1500);
    window.setTimeout(placeAvadaButton, 2500);
    maybeOpenSizeChartFromCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
